export enum SessionStorage {
  ParticipantPosition = 'participantPosition',
}
